import React, { useMemo, useState } from 'react'
import RenderFormSection from 'src/components/era-package/forms/RenderFormSection'
import { createDefaultValues } from 'src/components/era-package/forms/hooks/useFormConfig'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons'
import { optionsMap, authFormFields } from '../../shared'
import { Button } from '@mui/material'
import AbiStatementViewApiUrls from 'src/apiUrls/AbiStatementViewApiUrls'


const fieldMap = new Map([
  ['statementNumber', 'statementNumber'],
  ['statementType', 'statementType'],
  ['filerCode', 'filerCode'],
  ['portCode', 'port'],
  ['payerUnitNumber', 'payerUnitNumber'],
  ['paymentAmount', 'statementTotal']
])

export const Form = ({ onSubmit, ...statement }) => {
  const formFields = useMemo(() => {
    // Map statement data to form fields
    return authFormFields.map(field => {
      const mappedKey = fieldMap.get(field.name)
      return (mappedKey && statement.hasOwnProperty(mappedKey))
        ? { ...field, defaultValue: statement[mappedKey] }
        : field
    })
  }, [statement])

  const [formData, setFormData] = useState(createDefaultValues(formFields))

  // INTEGRATION: handle form submission
  const handleSubmit = async () => {
    console.log('Form data:', formData)

    try {
      const response = await fetch(AbiStatementViewApiUrls.SUBMIT_AUTHZ, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        },
        body: JSON.stringify(formData) // Convert JS object to JSON string
      });

      if (!response.ok) {
        console.error('Error submitting authz');
      }

      const result = await response.json();
      console.log('Authz submitted successfully:', result);
      
      if (onSubmit) {
        onSubmit(result.data); // or pass formData if result is empty
      }
    } catch (error) {
      console.error('Error submitting authz:', error);
    }
  }
  // END INTEGRATION

  return <>
    <RenderFormSection section={{
      title: 'Submit Statement Authorization',
      fields: formFields,
      icon: <FontAwesomeIcon icon={faFileInvoiceDollar} />
    }}
      formData={formData}
      setFormData={setFormData}
      optionsMap={optionsMap}
      actions={<Button variant='contained' color='primary'
        sx={{ minWidth: 120 }} onClick={handleSubmit}
      >
        Submit
      </Button>}
    />
  </>
}